import {TableSettings} from "../../../tableSettings";

export const containerStatusList:TableSettings = {
  tableVersion: 10063,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: []
};

export const myEventList: TableSettings ={
  tableVersion: 10058,
  overflowX: 'scroll',
  overflowY: 'scroll',
  showNewRowPlaceholder: false,
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: [
    { accessor:'status',              Header: ' ',                visible: true, width: 30,  canBeHidden: false, resizable: false, sortable: false },
    { accessor:'eventStatus',         Header: 'My Events',        visible: true, width: 125, canBeHidden: true,  resizable: true, sortable: true, filterable: true, filterType: 'text', defaultColumnFocus: true },
    { accessor:'containerNo',         Header: 'CNTR #',          visible: true, width: 100,  canBeHidden: true,  resizable: true, sortable: true, filterable: true, filterType: 'text', defaultColumnFocus: true },
    { accessor:'mblNo',               Header: 'MBL #',           visible: true, width: 100,  canBeHidden: true,  resizable: true, sortable: true, filterable: true, filterType: 'text' },
    // { accessor:'trStatus',            Header: 'TR',                visible: true, width: 30,  canBeHidden: true,  resizable: true, sortable: true, filterable: true, filterType: 'text' },
    // { accessor:'te',                  Header: 'T',                visible: true, width: 30,  canBeHidden: true,  resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'cargo',               Header: 'Cargo',            visible: true, width: 50,  canBeHidden: true,  resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'hblNo',               Header: 'HBL #',            visible: true, width: 100,  canBeHidden: true,  resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'pod',                 Header: 'POD',              visible: true, width: 100,  canBeHidden: true,  resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'anSentDate',          Header: 'A/N Sent',         visible: true, width: 75,  canBeHidden: true,  resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'eta',                 Header: 'ETA',              visible: true, width: 75,  canBeHidden: true,  resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'lastFreeDay',         Header: 'LFD',              visible: true, width: 75,  canBeHidden: true,  resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'vesselArrivalDate',   Header: 'Vessel ARR',       visible: true, width: 75,  canBeHidden: true,  resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'unloadVesselDate',    Header: 'Vessel ULD',       visible: true, width: 75,  canBeHidden: true,  resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'railDepartureDate',   Header: 'Rail DEP',         visible: true, width: 75,  canBeHidden: true,  resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'railArrivalDate',     Header: 'Rail ARR',         visible: true, width: 75,  canBeHidden: true,  resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'carrierRlsDate',      Header: 'Carrier Rel.',     visible: true, width: 75,  canBeHidden: true,  resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'customsRlsDate',      Header: 'Customs Rel.',     visible: true, width: 75,  canBeHidden: true,  resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'pickupAvailableDate', Header: 'Pickup Avail',     visible: true, width: 75,  canBeHidden: true,  resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'pickupDate',          Header: 'Pickup',           visible: true, width: 75,  canBeHidden: true,  resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'emptyCntrRtnDate',    Header: 'Emp RTN',          visible: true, width: 75,  canBeHidden: true,  resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'billingsDate',        Header: 'Billings',         visible: true, width: 75,  canBeHidden: true,  resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'consignee',           Header: 'Consignee',        visible: true, width: 110,  canBeHidden: true,  resizable: true, sortable: true, filterable: true, filterType: 'text' },
    // { accessor:'trDate',              Header: 'Req Date',         visible: true, width: 75,  canBeHidden: true,  resizable: true, sortable: true, filterable: true, filterType: 'date' },
  ]
}

export const vesselInfoList:TableSettings = {
  tableVersion: 1005,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: [
    { accessor:'status', Header: 'S', visible: true, width: 30, canBeHidden: false, resizable: false, sortable: false },
    { accessor:'vessel', Header: 'Vessel Name', visible: true, width: 150, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text', defaultColumnFocus: true },
    { accessor:'voyage', Header: 'Voyage #',   visible: true, width: 80, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'discharge', Header: 'Discharge Port', visible: true, width: 150, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'eta', Header: 'ETA', visible: true, width: 75, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
  ]
};

export const amsVoyageList:TableSettings = {
  tableVersion: 1006,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: [
    { accessor:'status', Header: ' ', visible: true, width: 30, canBeHidden: false, resizable: false, sortable: false },
    { accessor:'id', Header: 'AMS ID', visible: true, width: 180, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text', defaultColumnFocus: true },
    { accessor:'amsStatus', Header: 'S', visible: true, width: 180, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'userId', Header: 'User', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'block', Header: 'Block', visible: true, width: 180, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'vesselName', Header: 'Vessel Name', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'voyage', Header: 'Voyage #',   visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'lloyds', Header: 'Lloyds', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'loadPort', Header: 'Loading Port', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'etd', Header: 'ETD', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'lastPort', Header: 'Foreign Last Port', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'lastETD', Header: 'ETD', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'firstPort', Header: 'First US Port', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'eta', Header: 'ETA', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
  ]
};

export const amsMblList:TableSettings = {
  tableVersion: 1006,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: [
    { accessor:'status', Header: ' ', visible: true, width: 30, canBeHidden: false, resizable: false, sortable: false },
    { accessor:'id', Header: 'AMS ID', visible: true, width: 180, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text', defaultColumnFocus: true },
    { accessor:'amsStatus', Header: 'S', visible: true, width: 180, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'userId', Header: 'User', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'block', Header: 'Block', visible: true, width: 180, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'branch', Header: 'BR', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'manifestSeq', Header: 'Manifest #',   visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'mblNo', Header: 'MBL #',   visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'vesselName', Header: 'Vessel Name', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'voyage', Header: 'Voyage #',   visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'onBoard', Header: 'Org. Load ETD', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'loadEtd', Header: 'M. Vessel ETD', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'eta', Header: 'ETA', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'loadingPort', Header: 'Loading Port', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'discharge', Header: 'Discharge Port', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'finalDest', Header: 'Final Destination', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'notify', Header: 'Notify', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'containerNo', Header: 'Container #',   visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
  ]
};

export const amsHblList:TableSettings = {
  tableVersion: 1007,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: [
    { accessor:'customStatus', Header: ' ', visible: true, width: 30, canBeHidden: false, resizable: false, sortable: false },
    { accessor:'id', Header: ' ', visible: true, width: 30, canBeHidden: false, resizable: false, sortable: false },
    { accessor:'amsStatus', Header: 'AMS ID', visible: true, width: 180, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text', defaultColumnFocus: true },
    { accessor:'userId', Header: 'S', visible: true, width: 180, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'block', Header: 'User', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'branch', Header: 'Block', visible: true, width: 180, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'vSendDate', Header: 'Send Date', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'status', Header: 'Error Status', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'responseCode', Header: 'DP', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'manifestSeq', Header: 'Manifest #',   visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'hblNo', Header: 'MBL #',   visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'mblNo', Header: 'HBL#',   visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'vesselName', Header: 'Vessel Name', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'voyage', Header: 'Voyage #',   visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'coLoadAms', Header: 'Co-Load', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'coLoadAmsbl', Header: 'Co-Load B/L', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'responseDate', Header: 'response', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'statusRemark', Header: 'Status', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'sName', Header: 'Shipper', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'cName', Header: 'Consignee #',   visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'nName', Header: 'Notify', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'loadPort', Header: 'Loading Port', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'dCode', Header: 'Discharge Port', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'eta', Header: 'ETA', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'loadEtd', Header: 'L. Port ETD', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'moveType', Header: 'H. Move Type', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'onBoard', Header: 'Onboard', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
  ]
};

export const amsUsersList:TableSettings = {
  tableVersion: 1004,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: [
    { accessor:'status', Header: ' ', visible: true, width: 30, canBeHidden: false, resizable: false, sortable: false },
    { accessor:'id', Header: 'User ID', visible: true, width: 30, canBeHidden: false, resizable: false, sortable: false },
    { accessor:'amsID', Header: 'SCAC', visible: true, width: 180, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text', defaultColumnFocus: true },
    { accessor:'userID', Header: 'User', visible: true, width: 180, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'passWord', Header: 'Password', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'name', Header: 'User Name', visible: true, width: 180, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'email', Header: 'Email', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'amsSubGroup', Header: 'Branch', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'agentId', Header: 'Agent ID', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'active', Header: 'InactiveNo', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
  ]
};

export const amsBranchList:TableSettings = {
  tableVersion: 1002,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: [
    { accessor:'status', Header: 'S', visible: true, width: 30, canBeHidden: false, resizable: false, sortable: false },
    { accessor:'amsID', Header: 'SCAC', visible: true, width: 180, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text', defaultColumnFocus: true },
    { accessor:'branch', Header: 'Branch', visible: true, width: 180, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'email', Header: 'Email', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
  ]
};

export const amsBillingCodeList:TableSettings = {
  tableVersion: 1002,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: [
    { accessor:'status', Header: ' ', visible: true, width: 30, canBeHidden: false, resizable: false, sortable: false },
    { accessor:'amsBillingCode', Header: 'Billing Code', visible: true, width: 180, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text', defaultColumnFocus: true },
    { accessor:'description', Header: 'Description', visible: true, width: 180, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
  ]
};

export const amsHistoryCodeList:TableSettings = {
  tableVersion: 1005,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: [
    { accessor:'status', Header: ' ', visible: true, width: 30, canBeHidden: false, resizable: false, sortable: false },
    { accessor:'userID', Header: 'User', visible: true, width: 180, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text', defaultColumnFocus: true },
    { accessor:'amsMessage', Header: 'DP', visible: true, width: 180, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'date', Header: 'Date', visible: true, width: 180, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'description', Header: 'DP Description', visible: true, width: 180, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'hblNo', Header: 'HBL #',   visible: true, width: 180, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'mblNo', Header: 'MBL #',   visible: true, width: 180, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'sName', Header: 'Shipper', visible: true, width: 180, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'cName', Header: 'Consignee', visible: true, width: 180, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'nName', Header: 'Notify', visible: true, width: 180, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'voyage', Header: 'Voyage', visible: true, width: 180, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'eta', Header: 'ETA', visible: true, width: 180, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'dCode', Header: 'Discharge Port', visible: true, width: 180, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'conVName', Header: 'Vessel Name', visible: true, width: 180, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'moveType', Header: 'Move Type', visible: true, width: 180, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
  ]
};

export const amsCrHistoryCodeList:TableSettings = {
  tableVersion: 1005,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: [
    { accessor:'status', Header: ' ', visible: true, width: 30, canBeHidden: false, resizable: false, sortable: false },
    { accessor:'date', Header: 'Date', visible: true, width: 75, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date', defaultColumnFocus: true },
    { accessor:'hblNo', Header: 'HBL #',  visible: true, width: 180, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'hblNo', Header: 'Entry #',   visible: true, width: 180, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'containerNo', Header: 'Container #',   visible: true, width: 180, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'pkg', Header: 'Qty', visible: true, width: 180, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'number' },
  ]
};

export const aciVoyageList:TableSettings = {
  tableVersion: 1004,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: [
    { accessor:'status', Header: ' ', visible: true, width: 30, canBeHidden: false, resizable: false, sortable: false, hiddenInColumnSetup: true },
    { accessor:'id', Header: 'ID', visible: true, width: 180, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text', defaultColumnFocus: true },
    { accessor:'amsStatus', Header: 'S', visible: true, width: 180, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'userId', Header: 'User', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'block', Header: 'Block', visible: true, width: 180, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'vesselName', Header: 'Vessel Name', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'voyage', Header: 'Voyage #',   visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'lloyds', Header: 'Lloyds', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'loadPort', Header: 'Loading Port', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'etd', Header: 'ETD', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'lastPort', Header: 'Foreign Last Port', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'lastETD', Header: 'ETD', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'firstPort', Header: 'First US Port', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'eta', Header: 'ETA', visible: true, width: 85, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
  ]
};

export const releaseBlContainerTable:TableSettings = {
  tableVersion: 1003,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '80px',
  headersColor: 'white',
  useStorage: true,
  flexResizer: true,

  columns: [
    { Header: '', accessor: 'no', resizable: true, sortable: false, visible: true, initialWidthPercentage: 12, },
    { Header: 'Container #',   accessor: 'containerNo', resizable: true, sortable: false, visible: true, initialWidthPercentage: 73, },
    { Header: '', accessor: 'scroll', resizable: false, sortable: false, visible: true, initialWidthPercentage: 15, },
  ]
};

export const releaseBlPaybleTable:TableSettings = {
  tableVersion: 1002,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '80px',
  headersColor: 'white',
  useStorage: true,
  flexResizer: true,

  columns: [
    { Header: 'Date', accessor: 'postDate', resizable: true, sortable: false, visible: true, initialWidthPercentage: 8, },
    { Header: 'Vendor', accessor: 'vendorName', resizable: true, sortable: false, visible: true, initialWidthPercentage: 18, },
    { Header: 'Description', accessor: 'descript', resizable: true, sortable: false, visible: true, initialWidthPercentage: 20, },
    { Header: 'Invoice #',   accessor: 'invoiceNo', resizable: true, sortable: false, visible: true, initialWidthPercentage: 14, },
    { Header: 'Due Date', accessor: 'dueDate', resizable: true, sortable: false, visible: true, initialWidthPercentage: 9, },
    { Header: 'Amount', accessor: 'billAmt', resizable: true, sortable: false, visible: true, initialWidthPercentage: 10, },
    { Header: 'Paid Amount', accessor: 'paidAmt', resizable: true, sortable: false, visible: true, initialWidthPercentage: 10, },
    { Header: 'Status', accessor: 'status', resizable: true, sortable: false, visible: true, initialWidthPercentage: 7, },
    { Header: '', accessor: 'scroll', resizable: false, sortable: false, visible: true, initialWidthPercentage: 4, },
  ]
};

export const releaseBlReceivableTable:TableSettings = {
  tableVersion: 1003,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '80px',
  headersColor: 'white',
  useStorage: true,
  flexResizer: true,

  columns: [
    { Header: 'Inv. Date', accessor: 'invoiceDate', resizable: true, sortable: false, visible: true, initialWidthPercentage: 9, },
    { Header: 'Inv. #',  accessor: 'invoiceNo', resizable: true, sortable: false, visible: true, initialWidthPercentage: 23, },
    { Header: 'House B/L #',  accessor: 'hblNo', resizable: true, sortable: false, visible: true, initialWidthPercentage: 23, },
    { Header: 'Over Due', accessor: 'overDue', resizable: true, sortable: false, visible: true, initialWidthPercentage: 9, },
    { Header: 'Invo. Amount', accessor: 'invoiceAmt', resizable: true, sortable: false, visible: true, initialWidthPercentage: 11, },
    { Header: 'Balance', accessor: 'balance', resizable: true, sortable: false, visible: true, initialWidthPercentage: 9, },
    { Header: 'Paid Amount', accessor: 'paidAmt', resizable: true, sortable: false, visible: true, initialWidthPercentage: 11, },
    { Header: '', accessor: 'scroll', resizable: false, sortable: false, visible: true, initialWidthPercentage: 5, },
  ]
};

export const houseBillList:TableSettings = {
  tableVersion: 1002,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: []
};

